import atob from 'atob';

export default id => atob(id).split(':')[1];
